import { fetchTransport } from 'util/core/transport/fetch.transport'
import { type MarketCategoryInterface } from './type/market-category-type'
// import * as CategoryJson from './json/category-1.json'

class DataAccessCategories {
  public async getCategory (id: string): Promise<MarketCategoryInterface> {
    // return JSON.parse(JSON.stringify(CategoryJson)) as MarketCategoryInterface
    const response = await fetchTransport.get({
      url: `/api/categories/${id}`
    })

    if (response.status >= 400 && response.status < 600) {
      throw new Error(
        response.status.toString()
      )
    }

    const json = await response.json()

    return json
  }

  public async loadCategoryProfiles (
    id: string,
    filters: {
      page: number
      perPage: number
      pagination?: boolean
    }
  ): Promise<any> {
    const params = new URLSearchParams()
    params.append('page', String(filters.page))
    params.append('perPage', String(filters.perPage))
    if (filters.pagination) {
      params.append('pagination', String(filters.pagination))
    }
    const response = await fetchTransport.get({
      url: `/api/categories/${id}/profiles`,
      searchParams: params
    })

    if (response.status >= 400 && response.status < 600) {
      throw new Error(
        response.status.toString()
      )
    }

    const json = await response.json()

    const result = {
      items: [],
      total: 0
    }

    if (json['@type'] === 'hydra:Collection') {
      if (json['hydra:member'].length > 0) {
        result.total = json['hydra:totalItems']
        result.items = json['hydra:member']
      }
    }

    return result
  }
}

export const dataAccessCategories = new DataAccessCategories()
